var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.masterDataTitle
        ? _c("div", { staticClass: "row mb-1" }, [
            _c("div", { staticClass: "col" }, [
              _vm._v("\n      " + _vm._s(_vm.masterDataTitle) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "draggable",
        _vm._b(
          {
            staticClass: "list-group",
            attrs: { tag: "ul", handle: ".handle-dragable" },
            on: { start: _vm.handleStartDrag, end: _vm.handleEndDrag },
            model: {
              value: _vm.input,
              callback: function($$v) {
                _vm.input = $$v
              },
              expression: "input"
            }
          },
          "draggable",
          _vm.dragOptions,
          false
        ),
        [
          _c(
            "transition-group",
            {
              attrs: {
                name: !_vm.drag ? "flip-list" : null,
                type: "transition"
              }
            },
            _vm._l(_vm.mapInput, function(item, index) {
              return _c(
                "li",
                { key: "" + index, staticClass: "list-group-item" },
                [
                  _c("div", { staticClass: "wrapper-box" }, [
                    _c("div", { staticClass: "wrapper-box-form" }, [
                      _c("input", {
                        staticClass: "form-control form-control-sm input-name",
                        attrs: {
                          disabled: _vm.disabled || item.deletable === false
                        },
                        domProps: { value: item.name },
                        on: {
                          keyup: function($event) {
                            return _vm.handleInputChange($event, index)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showCheckboxDefault
                        ? _c("div", { staticClass: "default" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                staticClass: "form-check-input",
                                attrs: {
                                  id: _vm.radioId + "-" + index,
                                  disabled:
                                    _vm.disabled ||
                                    !item.is_active ||
                                    !item.name.trim().length,
                                  name: _vm.radioId,
                                  type: "radio"
                                },
                                domProps: {
                                  checked: item.is_default,
                                  value: item.name
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleRadioChange($event, index)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: _vm.radioId + "-" + index }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("message.default")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "active" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            staticClass: "form-check-input",
                            attrs: {
                              id: _vm.checkboxId + "-" + index,
                              disabled: _vm.disabled || item.is_default,
                              type: "checkbox"
                            },
                            domProps: { checked: item.is_active },
                            on: {
                              change: function($event) {
                                return _vm.handleCheckboxChange($event, index)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: _vm.checkboxId + "-" + index }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("message.activate")) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "delete" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-light",
                            attrs: {
                              disabled: _vm.disabled || !item.deletable
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeAt(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "far fa-trash-alt" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "drag handle-dragable" }, [
                        _c("i", { staticClass: "fa fa-align-justify" })
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-light btn-sm mt-3",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.add }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("button.addproduct")) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6029073e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6029073e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/CustomMasterDataForm.vue
// module id = null
// module chunks = 